import axios, { AxiosError } from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

interface HealthStatus {
  status: "ok";
  message?: string;
  timestamp?: string;
}

export const checkBackendHealth = async (): Promise<HealthStatus> => {
  try {
    const response = await axiosInstance.get<HealthStatus>("health", {
      headers: {
        "Cache-Control": "no-cache",
      },
      timeout: 8000,
    });

    const data = response.data;

    if (typeof data === "object" && data !== null && data.status === "ok") {
      return data;
    } else {
      console.warn(
        "Health check received 2xx status but invalid data format:",
        data
      );
      throw new Error(
        "Health check successful but received invalid response format."
      );
    }
  } catch (error) {
    console.error("Health check service error:", error);

    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        throw new Error(
          `Health check failed: Server responded with status ${axiosError.response.status}`
        );
      } else if (axiosError.request) {
        throw new Error(
          `Health check failed: No response received from server (${
            axiosError.code || "Network Error"
          }).`
        );
      } else {
        throw new Error(
          `Health check failed: Error setting up request (${axiosError.message})`
        );
      }
    } else if (error instanceof Error) {
      throw new Error(`Health check failed: ${error.message}`);
    } else {
      throw new Error("An unknown error occurred during health check.");
    }
  }
};
